module.exports = require('./module-anonymous')


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/plugin?auth-type!./common/js/src/edge/api/gw-portals-auth-angular/module.js
// module id = 150
// module chunks = 0